import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { SelfVoiceData } from '@shared/types';
import { selfApi } from './selfApi';
import SelfLogin from './SelfLogin';
import SelfEditPage from './SelfEditPage';
import { LanguageProvider, useT } from './i18n/LanguageProvider';
import styles from './Self.module.css';

// Öffentliche Self-Service-SPA — eigener Router-Zweig, KEIN AdminLayout, kein ZT.
// Auth läuft rein über das HttpOnly-Session-Cookie. Login-Erfolg = `getData` klappt:
// beim Mount wird `getData` probiert; scheitert es (401 ohne Cookie) → Login-Ansicht.
// Der Sprach-Provider umschließt Anmeldung UND Profil: die Wahl auf der
// Anmeldeseite gilt nach dem Login weiter (Spec 2026-09-15 Sprachumschalter).
export default function SelfApp() {
  return (
    <LanguageProvider>
      <SelfAppInhalt />
    </LanguageProvider>
  );
}

function SelfAppInhalt() {
  const { t } = useT();
  const { token } = useParams<{ token: string }>();
  const [data, setData] = useState<SelfVoiceData | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    if (!token) { setChecking(false); return; }
    selfApi
      .getData(token)
      .then((d) => { if (active) setData(d); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, [token]);

  if (!token) {
    return (
      <div className={styles.page}>
        <p className={styles.status}>{t.invalidLink}</p>
      </div>
    );
  }
  if (checking) {
    return (
      <div className={styles.page}>
        <p className={styles.status}>{t.loading}</p>
      </div>
    );
  }
  if (!data) {
    return <SelfLogin token={token} onSuccess={setData} />;
  }
  return <SelfEditPage token={token} initial={data} />;
}
